import type { Except, Merge } from 'type-fest';
import { useField } from '../../../hooks/useField';
import {
    Controlled_NumberInput,
    type Controlled_NumberInputProps,
    type NumberOrNullableNumber,
} from '../../inputs/controlled/Controlled_NumberInput';

export type Form_NumberInputProps<T extends object, N extends boolean> = Merge<
    Except<
        Controlled_NumberInputProps<N>,
        keyof useField.Result<NumberOrNullableNumber<N>>
    >,
    useField.Props<NumberOrNullableNumber<N>, T>
>;

export const Form_NumberInput = <T extends object, N extends boolean>({
    name,
    control,
    onChange,
    ...props
}: Form_NumberInputProps<T, N>) => {
    const fieldProps = useField({
        name,
        control,
        onChange,
    });

    return (
        <Controlled_NumberInput
            {...props}
            {...fieldProps}
        />
    );
};
